"use client";

import { useState, useEffect } from "react";
import { X, ExternalLink } from "lucide-react";
import { useLanguage } from "@/lib/i18n/LanguageContext";

export default function AnnouncementBar() {
    return null;
}
